import FormRealtorCards from '@components/enhanced-form/realtor-cards';

export default {
  props: {
    hasPrimaryAndSecondaryAgent: false,
    contactName: 'Jason Kenson',
    tourUrl: 'https://www.sibcycline.com',
    children: (
      <FormRealtorCards
        hasPrimaryAndSecondaryAgent={false}
        realtors={[
          {
            email: 'hello@example.com',
            languages: 'Spanish',
            name: 'Jason Kenson',
            photoUrl: 'https://i.stack.imgur.com/HQwHI.jpg',
            phone: '555-555-5555',
            professionalTitle: 'Realtor',
            websiteUrl: 'https://www.sibcycline.com'
          }
        ]}
      />
    )
  }
};
